import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Loader2, ArrowLeft, Send, CheckCircle2 } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { toast } from '../hooks/use-toast';
import api from '../lib/api';
import { BrandLogo } from '../components/BrandLogo';

const RecuperarPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast({ title: 'Error', description: err?.response?.data?.detail || 'Intenta de nuevo.' });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-160px)] flex items-center justify-center px-4 py-12 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-20 -left-20 w-[420px] h-[420px] rounded-full bg-orange-500/15 blur-[100px]" />
        <div className="absolute -bottom-20 -right-20 w-[380px] h-[380px] rounded-full bg-red-600/10 blur-[100px]" />
      </div>

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <BrandLogo size="md" />
        </div>
        <div className="rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-8 backdrop-blur">
          {sent ? (
            <div className="text-center py-4" data-testid="recover-success">
              <div className="w-16 h-16 mx-auto rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
                <CheckCircle2 className="w-8 h-8 text-emerald-400" />
              </div>
              <h1 className="mt-5 text-2xl md:text-3xl font-black text-white">Revisa tu correo</h1>
              <p className="mt-3 text-white/60 text-sm leading-relaxed">
                Si <strong className="text-white">{email}</strong> está registrado, te enviamos un enlace para restablecer tu contraseña. El enlace expira en <strong className="text-orange-400">1 hora</strong>.
              </p>
              <p className="mt-4 text-[11px] text-white/40">¿No lo ves? Revisa tu carpeta de spam o correos promocionales.</p>
              <Link to="/inicio-sesion" className="mt-6 inline-flex items-center gap-1.5 text-orange-400 hover:text-orange-300 text-sm font-bold">
                <ArrowLeft className="w-4 h-4" /> Volver a inicio de sesión
              </Link>
            </div>
          ) : (
            <>
              <Link to="/inicio-sesion" className="inline-flex items-center gap-1.5 text-white/50 hover:text-white text-xs font-bold mb-4">
                <ArrowLeft className="w-3.5 h-3.5" /> Volver
              </Link>
              <h1 className="text-3xl md:text-4xl font-black text-white tracking-tight">
                Recuperar <span className="text-orange-400">contraseña</span>
              </h1>
              <p className="mt-2 text-white/60 text-sm">Ingresa tu correo y te enviaremos un enlace para elegir una nueva contraseña.</p>
              <form onSubmit={submit} className="mt-6 space-y-4" data-testid="recover-form">
                <div>
                  <label className="text-[11px] font-bold uppercase tracking-wider text-white/50">Correo electrónico</label>
                  <div className="relative mt-2">
                    <Mail className="w-4 h-4 text-white/40 absolute left-3.5 top-1/2 -translate-y-1/2" />
                    <Input type="email" name="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" className="h-12 pl-10 bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-orange-500/50" data-testid="recover-email-input" />
                  </div>
                </div>
                <Button type="submit" disabled={loading || !email} className="w-full h-13 h-14 rounded-full bg-orange-500 hover:bg-orange-600 text-black font-bold text-base shadow-lg shadow-orange-500/25" data-testid="recover-submit-btn">
                  {loading ? <><Loader2 className="w-5 h-5 mr-2 animate-spin" /> Enviando…</> : <><Send className="w-4 h-4 mr-2" /> Enviar enlace</>}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecuperarPage;
